import { useState, useEffect } from "react";
import { db } from "../firebase/config";
import { collection, query, orderBy, onSnapshot, where, limit } from "firebase/firestore";

export const useFetchDocuments = (docCollection, uid = undefined, transaction = false, limitOn = false) => {

    const [documents, setDocuments] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(null);

    useEffect(() => {
        setLoading(true);
        setError(null);

        const missingScopedUser = (transaction && !uid) || (docCollection === "users" && uid === null);
        if (!docCollection || missingScopedUser) {
            setDocuments([]);
            setLoading(false);
            return;
        }

        const collectionRef = collection(db, docCollection);
        let q;

        if (uid && !transaction) {
            q = query(
                collectionRef,
                where("id", "==", uid),
            );
        } else if (uid && transaction) {
            q = query(
                collectionRef,
                where("uid", "==", uid)
            );
        } else if ((docCollection === 'day-off' || docCollection === 'transactions') && limitOn) {
            q = query(
                collectionRef,
                orderBy('createdAt', 'desc'),
                limit(10)
            );
        } else {
            q = query(collectionRef, orderBy("createdAt", "desc"))
        }

        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            const loadedDocuments = querySnapshot.docs
                .map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }))
                .sort((a, b) => {
                    const aCreatedAt = a.createdAt?.seconds || 0;
                    const bCreatedAt = b.createdAt?.seconds || 0;

                    return bCreatedAt - aCreatedAt;
                });

            setDocuments(transaction ? loadedDocuments.slice(0, 5) : loadedDocuments);
            setLoading(false);
        }, (error) => {
            console.log(error);
            setError(error.message);
            setDocuments([]);
            setLoading(false);
        });

        return unsubscribe;

    }, [docCollection, uid, transaction, limitOn])

    return { documents, loading, error };
};
